
<div class="content-wrapper pt-2"> 
  <section class="content">
   
    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header"> Quotation</div> 
      <form [formGroup]="quotationForm"  autocomplete="off"  class="form-horizontal">   
      <div class="card-body">   
          
        <div class="row">    
          <div class="col-md-3">
            <div class="form-group">
              <label for="quotationNo" class="col-form-label">Quotation No</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="quotationNo" class="form-control field-bg-color" [class.is-invalid]="formErrors.quotationNo" (blur)="logValidationErrors()" placeholder="Quotation No">
              </div>
              <span class="text-danger" *ngIf="formErrors.quotationNo"><small>{{formErrors.quotationNo}}</small> </span>   
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="quotationDate" class="col-form-label">Quotation Date </label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                </div>
                <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="quotationDate" class="form-control field-bg-color"  [class.is-invalid]="formErrors.quotationDate" (blur)="logValidationErrors()" placeholder="Quotation Date">
              </div>
              <span class="text-danger" *ngIf="formErrors.quotationDate"><small>{{formErrors.quotationDate}}</small> </span>   
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="dc20" class="col-form-label">Detention Charges 1 x 20</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                </div>
                <input  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="dc20"  placeholder="DC 1x20">
              </div>
            </div>
          </div> 
          <div class="col-md-3">
            <div class="form-group">
              <label for="dc40" class="col-form-label">Detention Charges 1 x 40</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                </div>
                <input  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="dc40"  placeholder="DC 1x40">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="dft" class="col-form-label">Detention Free Time</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-balance-scale"></i></span>
                </div>
                <select  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="dft">
                  <option [ngValue]="null">-Select-</option>
                  <option *ngFor = "let item of DFT" [value]="item.value">
                    {{item.value}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <input  name="cusId" readonly formControlName="cusId"   class="form-control"    type="hidden">
            </div>          
            <div class="col-md-4">
              <div class="form-group">
                <label for="cusName" class="col-form-label">Customer</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                  </div>
                  <input [ngClass]="{'dark-input-field' : isDark }" type="text" formControlName="cusName" (focusout)="getCustomerDetails()"  [matAutocomplete]="autoCustomer" class="form-control field-bg-color"  [class.is-invalid]="formErrors.cusName" (blur)="logValidationErrors()" placeholder="Customer Name">
                  <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                    <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.CusName">
                      {{option.CusName}}
                    </mat-option>
                  </mat-autocomplete> 
                </div>
                <span class="text-danger" *ngIf="formErrors.cusName"><small>{{formErrors.cusName}}</small> </span>               
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label for="address" class="col-form-label">Address</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                  </div>
                  <input readonly [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="address" [class.is-invalid]="formErrors.address" (blur)="logValidationErrors()" placeholder="Address">
                </div>
                <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
              </div>
            </div> 
        </div>

   
        <!-- Invoice Items -->   
        <div class="row"> 
        <div class="col-md-12">
          <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
            <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
              <tr>
                <th style="width: 10%"  scope="col">Item Code</th>
                <th style="width: 15%"  scope="col">Description</th>
                <th style="width: 15%"  scope="col">From</th>
                <th style="width: 15%"  scope="col">To</th>
                <th style="width: 14%"  scope="col">ContainerType</th>
                <th style="width: 12%"  scope="col" style="text-align: center">UnitPrice</th>
                <th style="width: 5%"  scope="col" style="text-align: center">Qty</th>
                <th style="width: 12%" scope="col" style="text-align: center">Amount</th>
                <th *ngIf="!isHideBtn"></th> 
              </tr>
              </thead>
  
              <tbody class="ml-1" formArrayName="invoiceItems" *ngFor="let invoiceItem of quotationForm.get('invoiceItems')['controls']; let i = index">                    
                    <tr [formGroupName] = "i" >                      
                      <td><input  (focusout)="getItemData(i);calEachItemAmount(i)" [matAutocomplete]="auto" [readonly]="isfieldReadOnly" [ngClass]="{'dark-input-field' : isDark }" type="text"  class="form-control form-control-sm field-bg-color" formControlName="itemCode" [class.is-invalid]="invoiceItem.get('itemCode').invalid && invoiceItem.get('itemCode').touched">
                        <mat-autocomplete autoActiveFirstOption   #auto="matAutocomplete">
                          <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option.ItemCode">
                            {{option.ItemCode}}
                          </mat-option>
                        </mat-autocomplete> 
                      </td>   
                                         
                        <td><input [ngClass]="{'dark-input-field' : isDark }"   type="text" readonly class="form-control form-control-sm field-bg-color" formControlName="description" [class.is-invalid]="invoiceItem.get('description').invalid && invoiceItem.get('description').touched"></td> 
                       
                        <td>
                          <select [ngClass]="{'dark-input-field' : isDark }" (change)="fromLocationChangeEvent($event)"   type="text"  class="form-control form-control-sm field-bg-color" formControlName="fromLocation" [class.is-invalid]="invoiceItem.get('fromLocation').invalid && invoiceItem.get('fromLocation').touched">
                            <option [ngValue]="null">-Select-</option>
                            <option  [ngValue]="null">(+) New</option>
                            <option  *ngFor="let item of locationList" [value]="item.Location">
                              {{item.Location}}
                            </option>
                          </select>
                          </td> 

                        <td>
                          <select [ngClass]="{'dark-input-field' : isDark }"  (change)="toLocationChangeEvent($event)"  type="text"  class="form-control form-control-sm field-bg-color" formControlName="toLocation" [class.is-invalid]="invoiceItem.get('toLocation').invalid && invoiceItem.get('toLocation').touched">
                            <option [ngValue]="null">-Select-</option>
                            <option [ngValue]="null">(+) New</option>
                            <option  *ngFor="let item of locationList" [value]="item.Location">
                              {{item.Location}}
                            </option>
                          </select>
                          </td>

                        <td>
                          <select [ngClass]="{'dark-input-field' : isDark }" (change)="containerTypeChangeEvent($event)"  type="text"  class="form-control form-control-sm field-bg-color" formControlName="containerType" [class.is-invalid]="invoiceItem.get('containerType').invalid && invoiceItem.get('containerType').touched">
                            <option [ngValue]="null">-Select-</option>
                            <option [ngValue]="null">(+) New</option>
                            <option  *ngFor="let item of containerTypeList" [value]="item.ContainerType">
                              {{item.ContainerType}}
                            </option>
                          </select>
                          </td> 

                        <td><input [ngClass]="{'dark-input-field' : isDark }" type="text" (keyup)="calEachItemAmount(i)"  style="text-align: right"   class="form-control form-control-sm field-bg-color" formControlName="unitPrice" allowNumberOnly [class.is-invalid]="invoiceItem.get('unitPrice').invalid && invoiceItem.get('unitPrice').touched"></td>  
                        <td><input (focusout)="calEachItemAmount(i)" (keyup)="calEachItemAmount(i)"  [ngClass]="{'dark-input-field' : isDark }"  [readonly]="isfieldReadOnly" type="text"  style="text-align: right" allowNumberOnly   class="form-control form-control-sm field-bg-color" formControlName="qty" [class.is-invalid]="invoiceItem.get('qty').invalid && invoiceItem.get('qty').touched"></td>  
                        <td><input (focusout)="calEachItemAmount(i)"  [ngClass]="{'dark-input-field' : isDark }"  type="text" style="text-align: right"  readonly class="form-control form-control-sm field-bg-color" formControlName="amount" [class.is-invalid]="invoiceItem.get('amount').invalid && invoiceItem.get('amount').touched"></td>  
                        <td *ngIf="!isHideBtn">
                          <button type="button" *ngIf="!isBtnDisabled && quotationForm.get('invoiceItems').length > 1" class="btn btn-danger btn-sm ml-1 text-white" (click)="removeItemButtonClick(i)" data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="fa fa-close"></i></button>         
                      </td>                   
                      </tr>                                                         
              </tbody>
              <tfoot *ngIf="!isHideBtn">
                <tr>
                  <td colspan="9"><button type="button"   [disabled]="isBtnDisabled || quotationForm.get('invoiceItems').invalid"  class="btn btn-success btn-sm text-white float-right" (click)="addItemButtonClick()"><i class="fa fa-plus"></i> Add</button></td>
                </tr>   
              </tfoot>
          </table> 
      </div> 
    </div>

        <div class="row mt-3 mr-4">
          <div class="col-md-6" >
            <div class="form-group">
                <label for="remarks" class="col-form-label">Remarks</label>
                <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-pencil-square-o"></i></span>
                </div>
                <textarea rows="3"  [ngClass]="{'dark-input-field' : isDark }" class="form-control field-bg-color" formControlName="remarks"   placeholder="Remarks"></textarea>
                </div>  
            </div>
        </div>
          <div class="col-md-4 offset-2">
            <table class="table table-clear" [ngClass]="{'dark-bg' : isDark }">
              <tbody>
              <tr>
              <td class="left">
              <strong>Total</strong>
              </td>
              <td class="text-right">{{quotation.grandTotal|  number:'1.2-2'}}</td>
              </tr>              
              </tbody>
              </table>
          </div>
      </div>
      <!-- <div class="row mt-3 mr-4">
      <div class="col-md-3">
        <table class="table table-clear" [ngClass]="{'dark-bg' : isDark }">
          <tbody>
          <tr>
          <td class="left">
          <strong>Status</strong>
          </td>
          <td class="text-right">{{quotation.status}}</td>
          </tr>              
          </tbody>
          </table>
    </div>
    </div> -->

    
      </div>
      
      <!-- /.card-body -->
        
      <div class="card-footer">
      <button type="button"  *ngIf="crud_access.create" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>
        <button   *ngIf="crud_access.create" type="button" [disabled]="isBtnDisabled"  (click)="saveButtonClick()" class="btn btn-info ml-2">
         <span *ngIf ="showProcessingIndicator" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          Save
        </button>
        <!-- <button *ngIf="crud_access.approve" class="btn btn-info ml-2"  (click)="approvedButtonButtonClicked()">Approve</button> -->
        <button type="button"  *ngIf="crud_access.delete" class="btn btn-danger ml-2" [disabled]="isCancelBtnDisabled" (click)="deleteButtonClick()">Cancel</button>       
        <button type="button"  class="btn btn-success ml-2" routerLink="../quotation-list"><i class="fa fa-table p-1"></i>Quotation List</button>
        <!-- <button class="btn btn-info ml-2" [disabled]="isCreateInvoiceBtnDisabled" (click)="createInvoiceButtonClicked()">Create Invoice</button> -->
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>

        <button type="button"  (click)="savePDF('print')"  mat-icon-button class="text-info float-right">
          <mat-icon>print</mat-icon>
        </button>
        <button type="button"  (click)="savePDF('download')"  mat-icon-button class="text-success float-right">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button type="button" (click)="savePDF('open')"  mat-icon-button class="text-dark float-right">
          <mat-icon [ngClass]="{'dark-bg' : isDark }">preview</mat-icon>
        </button>
      
      </div>

      </form>
    </div>

  </section>

</div> 

 
<!-- Form Values : {{ quotationForm.value | json }}  -->




